namespace Nobox.CRM {
    export interface NotifRow {
        Id?: number;
        UserId?: number;
        ToServer?: string;
        Icon?: string;
        Title?: string;
        Message?: string;
        Action?: string;
        Menu?: string;
        RepeatAction?: number;
        IsRead?: number;
        Time?: string;
    }

    export namespace NotifRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Title';
        export const localTextPrefix = 'Nobox.Notif';
        export const deletePermission = 'Tasks:Delete';
        export const insertPermission = 'Tasks:Modify';
        export const readPermission = 'Tasks:View';
        export const updatePermission = 'Tasks:Modify';

        export declare const enum Fields {
            Id = "Id",
            UserId = "UserId",
            ToServer = "ToServer",
            Icon = "Icon",
            Title = "Title",
            Message = "Message",
            Action = "Action",
            Menu = "Menu",
            RepeatAction = "RepeatAction",
            IsRead = "IsRead",
            Time = "Time"
        }
    }
}
